import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {UrlBuilder} from "../../repositories/item/url.item";

export const authInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {

  if (request.headers.has(UrlBuilder.API_HEADER)) {
    request = request.clone({withCredentials: true});
  }
  return next(request);
};
